import "./OrganizationChart.css";
import { useNavigate, useParams } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import { APICall } from "../../Helpers/API/APICalls";

import { OrgChartComponent } from "./OrgChart";

import {
  getUserHirerarchEmployee,
  getUserHirerarchManagerEmployee,
  getUserHierarchyEmployeeChildrens,
  GetDropDownList,
} from "../../Helpers/API/APIEndPoints";

import { getContext, LoaderContext } from "../../Helpers/Context/Context";
import { Mp } from "@mui/icons-material";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { Autocomplete } from "@mui/material";
import { TextField } from "@material-ui/core";
import SelectForm from "../../Components/SelectForm/SelectForm";

export default function TemplateDemo() {
  const navigate = useNavigate();
  const { id } = useParams();
  const context = getContext();
  const EmployeeId = context.EmployeeId;
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [EmpName, setEmpName] = useState("");

  const [data2, SetData2] = useState(
    // 2415
    id != null ? id : id
  );

  const [dataForTree, setDataForTree] = useState([]);
  const [resourceAllocatedOptions, setResourceAllocatedOptions] = useState<any>(
    []
  );
  const [resourceAllocated, setResourceAllocated] = useState<any>({
    value: Number(EmployeeId),
  });
  const [envteam, setEnvteam] = useState<any>(
    process.env.REACT_APP_PUBLISH_PATH ? process.env.REACT_APP_PUBLISH_PATH : ""
    // process.env.REACT_APP_Login_PATH ? process.env.REACT_APP_Login_PATH : ""
  );
  const [inputValue, setInputValue] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  let addNodeChildFunc = null;
  useEffect(() => {
    showLoader();
    const fetching = async () => {
      await fetchManagerData();
    };
    fetching();

    hideLoader();
  }, [data2]);

  const fetchManagerData = async () => {
    let Managerdata = await getMangerData();
    let empC = await getEmployeeData();
    if (Managerdata.length > 0 && empC[0].id === Managerdata[0].id) {
      let child = await getChildrenData();
      let emp = await getEmployeeData();
      emp[0].id = emp[0].toString();
      emp[0].parentId = "";
      child.map((child) => {
        child.parentId = emp[0].id.toString();
      });

      setDataForTree([...emp, ...child]);
    } else if (Managerdata.length > 0) {
      Managerdata[0].parentId = "";
      let emp = await getEmployeeData();
      let child = await getChildrenData();
      child.map((child) => {
        child.parentId = emp[0].id.toString();
      });
      emp[0].parentId = Managerdata[0].id.toString();

      setDataForTree([...Managerdata, ...emp, ...child]);
    } else {
      let emp = await getEmployeeData();
      let child = await getChildrenData();
      emp[0].parentId = "";
      child.map((child) => {
        child.parentId = emp[0].id.toString();
      });
      setDataForTree([...emp, ...child]);
    }
  };

  const fetchingEmployeeData = async (apiCall, data2) => {
    try {
      showLoader();
      const response = await APICall(apiCall, "POST", { Id: data2 });

      return response;
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      hideLoader();
    }
  };

  const getMangerData = async () => {
    const managerReponse = await fetchingEmployeeData(
      getUserHirerarchManagerEmployee,
      data2
    );

    return managerReponse.data;
  };

  const getEmployeeData = async () => {
    const response = await fetchingEmployeeData(
      getUserHirerarchEmployee,
      data2
    );

    return response.data;
  };

  const getChildrenData = async () => {
    const response = await APICall(getUserHierarchyEmployeeChildrens, "POST", {
      Id: data2,
    });

    return response.data;
  };

  //handling node click
  function onNodeClick(nodeId) {
    SetData2(String(nodeId.data.id));
  }

  //Prashant
  const defaultProps = {
    options: resourceAllocatedOptions,
    getOptionLabel: (option: any) => option.label,
  };
  const handleInputChange = (event, value, reason) => {
    setEmpName(event.Label);
    window.location.href = `${envteam}/TeamStructure/${event.value}`;
  };

  useEffect(() => {
    resourceApiCall();
  }, []);

  const resourceApiCall = async () => {
    let postObject = {
      searchFor: "employee",
      searchValue: 1,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);

    if (data != undefined || data != null) {
      let employeeArray = [];
      await data.map((employee: any) => {
        let tempObj = {
          value: employee.id,
          label: employee.name,
        };
        if (tempObj.value == resourceAllocated.value) {
          setResourceAllocated(tempObj);
        }
        employeeArray.push(tempObj);
      });
      setResourceAllocatedOptions(employeeArray);
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-3" style={{ position: "absolute", background: "#fff", zIndex: "9" }}> 
            <div
              className="form-group select_emp"
            >
              <label>Select Employee</label>
              <SelectForm
                {...defaultProps}
                placeholder="Select"
                //isDisabled={false}
                isDisabled={false}
                value={EmpName}
                onChange={handleInputChange}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              {/* <Autocomplete
                    {...defaultProps}
                    onChange={handleInputChange}
                    id="SelectEmployee"
                    clearOnEscape
                    onInputChange={(_, newInputValue) => setInputValue(newInputValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                       // label="Select Employee"
                        variant="standard"
                        fullWidth
                        value={inputValue}
                      />
                    )}
                    
                   /> */}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <OrgChartComponent
              setClick={(click) => (addNodeChildFunc = click)}
              onNodeClick={onNodeClick}
              data={dataForTree}
            />
          </div>
        </div>
      </div>
    </>
  );
}
